<main *ngIf="!showAddressForm" class="w-full p-0 max-md:pt-1">
  <!-- Header -->
  <header class="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full font-bold">
    <h1 class="text-2xl text-black mb-4 sm:mb-0 max-md:text-xl max-md:mb-3">Saved Addresses</h1>
    <nav class="flex sm:flex-row gap-3 sm:gap-4 sm:items-end sm:mt-0">
      <button type="button"
        class="flex items-center justify-center gap-2 px-3 py-2 border border-blue-900 rounded-lg w-full sm:w-auto"
        (click)="addressPopup('address')">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
          <path d="M12 12H17M12 12H7M12 12V7M12 12V17" stroke="#0A0A5F" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span class="text-base font-bold text-blue-950 whitespace-nowrap">Add Address</span>
      </button>
      <button *ngIf="canAddGstDetails" type="button"
        class="flex items-center justify-center gap-2 px-3 py-2 border border-blue-900 rounded-lg w-full sm:w-auto"
        (click)="gstPopup()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
          <path d="M12 12H17M12 12H7M12 12V7M12 12V17" stroke="#0A0A5F" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span class="text-sm font-bold text-blue-950 whitespace-nowrap">Add GST</span>
      </button>
    </nav>
  </header>

  <!-- Default Address -->
  <section class="mt-6" *ngIf="userData?.shipping_address || userData?.billing_address">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6 mt-4 items-stretch">
      <!-- Delivery column -->
      <div class="w-full min-w-0 address-default-card flex flex-col">
        <h2 class="text-sm font-bold text-zinc-700" *ngIf="userData?.only_one_address === true">Default Delivery &
          Billing Address</h2>

        <h2 class="text-sm font-bold text-zinc-700"
          *ngIf="userData?.only_one_address === false && userData?.shipping_address">Default Delivery Address</h2>
        <article class="p-4 sm:p-5 mt-2 bg-slate-50 border border-gray-200/80 rounded-xl w-full min-w-0 min-h-[180px] flex flex-col shadow-sm flex-grow"
          *ngIf="userData.shipping_address">
          <div class="flex justify-between items-start">
            <div class="flex gap-2 items-center">
              <h3 class="text-lg font-bold text-black">{{userData.shipping_address?.receiver_name ?
                userData.shipping_address?.receiver_name : userData.shipping_address?.company_name ?
                userData.shipping_address?.company_name : userData.first_name + ' ' + userData.last_name}}</h3>

              <span class="px-3 py-1 text-sm bg-gray-100 border border-gray-300 rounded-2xl text-black"
                *ngIf="userData.shipping_address?.address_type">{{userData.shipping_address?.address_type |
                titlecase}}</span>
            </div>
            <button class="flex items-center gap-1 text-sm font-semibold max-md:hidden hover:underline"
              [class.text-blue-500]="!userData?.shipping_address?.gstin_number"
              [class.text-gray-400]="userData?.shipping_address?.gstin_number"
              [class.cursor-not-allowed]="userData?.shipping_address?.gstin_number"
              [class.opacity-50]="userData?.shipping_address?.gstin_number"
              [disabled]="userData?.shipping_address?.gstin_number"
              (click)="!userData?.shipping_address?.gstin_number && editAddress(userData?.shipping_address, 'shipping')">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
                <path
                  d="M16.6667 12.2229L16.6667 14.4451C16.6667 15.6724 15.6718 16.6673 14.4445 16.6673H5.5556C4.3283 16.6673 3.33337 15.6724 3.33337 14.4451V5.55621C3.33337 4.32891 4.3283 3.33398 5.5556 3.33398H7.77782M12.9449 4.77431L7.11094 10.6083C6.95169 10.7675 6.84314 10.9703 6.79897 11.1912L6.44342 12.9689C6.37345 13.3188 6.68191 13.6272 7.03177 13.5573L8.80953 13.2017C9.03037 13.1575 9.23319 13.049 9.39244 12.8898L15.2264 7.05581M12.9449 4.77431L14.0511 3.6681C14.4966 3.22261 15.2189 3.22261 15.6644 3.6681L16.3326 4.33634C16.7781 4.78183 16.7781 5.50411 16.3326 5.9496L15.2264 7.05581M12.9449 4.77431L15.2264 7.05581"
                  [attr.stroke]="userData?.shipping_address?.gstin_number ? '#9CA3AF' : '#307FE1'"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>Edit</span>
            </button>
          </div>
          <div class="flex-grow mt-3">
            <p class="text-sm text-black font-medium leading-relaxed"> {{userData.shipping_address?.address_1}}
              {{userData.shipping_address?.land_mark}},{{userData.shipping_address?.state}},{{userData.shipping_address?.pincode}}
            </p>
            <p class="mt-2 text-sm text-gray-500 font-medium"
              *ngIf="userData.shipping_address?.receiver_phone_no || userData?.phone_number">Contact: <span
                class="font-bold text-black">{{userData.shipping_address?.receiver_phone_no ?
                userData.shipping_address?.receiver_phone_no : userData?.phone_number }}</span></p>
            <p class="mt-2 text-sm text-gray-500 font-medium" *ngIf="userData.shipping_address?.gstin_number">GST: <span
                class="font-bold text-black">{{userData.shipping_address?.gstin_number}}</span></p>
          </div>
          <div
            class="flex flex-wrap justify-between items-center gap-2 mt-4 text-sm font-bold text-blue-500 max-md:border-t max-md:border-gray-100 max-md:pt-3 max-md:justify-start">

            <!-- Desktop/Tablet: Remove on left -->
            <button class="text-blue-500 text-sm font-bold max-md:hidden hover:underline"
              (click)="confirmRemoveAddress(userData?.shipping_address?.id)">Remove</button>

            <!-- Mobile: Edit on left, separator, Remove on right -->
            <button class="hidden max-md:flex items-center gap-1 text-sm font-semibold"
              [class.text-blue-500]="!userData?.shipping_address?.gstin_number"
              [class.text-gray-400]="userData?.shipping_address?.gstin_number"
              [class.cursor-not-allowed]="userData?.shipping_address?.gstin_number"
              [class.opacity-50]="userData?.shipping_address?.gstin_number"
              [disabled]="userData?.shipping_address?.gstin_number"
              (click)="!userData?.shipping_address?.gstin_number && editAddress(userData?.shipping_address, 'shipping')">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
                <path
                  d="M16.6667 12.2229L16.6667 14.4451C16.6667 15.6724 15.6718 16.6673 14.4445 16.6673H5.5556C4.3283 16.6673 3.33337 15.6724 3.33337 14.4451V5.55621C3.33337 4.32891 4.3283 3.33398 5.5556 3.33398H7.77782M12.9449 4.77431L7.11094 10.6083C6.95169 10.7675 6.84314 10.9703 6.79897 11.1912L6.44342 12.9689C6.37345 13.3188 6.68191 13.6272 7.03177 13.5573L8.80953 13.2017C9.03037 13.1575 9.23319 13.049 9.39244 12.8898L15.2264 7.05581M12.9449 4.77431L14.0511 3.6681C14.4966 3.22261 15.2189 3.22261 15.6644 3.6681L16.3326 4.33634C16.7781 4.78183 16.7781 5.50411 16.3326 5.9496L15.2264 7.05581M12.9449 4.77431L15.2264 7.05581"
                  [attr.stroke]="userData?.shipping_address?.gstin_number ? '#9CA3AF' : '#307FE1'"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>Edit</span>
            </button>
            <span class="hidden max-md:inline-block h-4 w-px bg-gray-300 mx-1 self-center"></span>
            <button class="hidden max-md:block text-blue-500 text-sm font-bold"
              (click)="confirmRemoveAddress(userData?.shipping_address?.id)">Remove</button>

          </div>
        </article>
      </div>

      <!-- Billing column -->
      <div class="w-full min-w-0 address-default-card flex flex-col"
        *ngIf="userData?.only_one_address === false && userData.billing_address">
        <h2 class="text-sm font-bold text-zinc-700">Default Billing Address</h2>
        <article class="p-4 sm:p-5 mt-2 bg-slate-50 border border-gray-200/80 rounded-xl w-full min-w-0 min-h-[180px] flex flex-col shadow-sm flex-grow"
          *ngIf="userData.billing_address">
          <div class="flex justify-between items-start">
            <div class="flex gap-2 items-center">
              <h3 class="text-lg font-bold text-black" *ngIf="userData?.billing_address?.receiver_name">
                {{userData?.billing_address?.receiver_name}}</h3>
              <h3 class="text-lg font-bold text-black" *ngIf="userData?.billing_address?.company_name">
                {{userData?.billing_address?.company_name}}</h3>
              <span class="px-3 py-1 text-sm bg-gray-100 border border-gray-300 rounded-2xl text-black"
                *ngIf="userData?.billing_address?.address_type">{{userData?.billing_address?.address_type |
                titlecase}}</span>
            </div>
            <button class="flex items-center gap-1 text-sm font-semibold max-md:hidden hover:underline"
              [class.text-blue-500]="!userData?.billing_address?.gstin_number"
              [class.text-gray-400]="userData?.billing_address?.gstin_number"
              [class.cursor-not-allowed]="userData?.billing_address?.gstin_number"
              [class.opacity-50]="userData?.billing_address?.gstin_number"
              [disabled]="userData?.billing_address?.gstin_number"
              (click)="!userData?.billing_address?.gstin_number && editAddress(userData?.billing_address, 'billing')">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
                <path
                  d="M16.6667 12.2229L16.6667 14.4451C16.6667 15.6724 15.6718 16.6673 14.4445 16.6673H5.5556C4.3283 16.6673 3.33337 15.6724 3.33337 14.4451V5.55621C3.33337 4.32891 4.3283 3.33398 5.5556 3.33398H7.77782M12.9449 4.77431L7.11094 10.6083C6.95169 10.7675 6.84314 10.9703 6.79897 11.1912L6.44342 12.9689C6.37345 13.3188 6.68191 13.6272 7.03177 13.5573L8.80953 13.2017C9.03037 13.1575 9.23319 13.049 9.39244 12.8898L15.2264 7.05581M12.9449 4.77431L14.0511 3.6681C14.4966 3.22261 15.2189 3.22261 15.6644 3.6681L16.3326 4.33634C16.7781 4.78183 16.7781 5.50411 16.3326 5.9496L15.2264 7.05581M12.9449 4.77431L15.2264 7.05581"
                  [attr.stroke]="userData?.billing_address?.gstin_number ? '#9CA3AF' : '#307FE1'" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <span>Edit</span>
            </button>
          </div>
          <div class="flex-grow mt-3">
            <p class="text-sm text-black font-medium leading-relaxed"> {{userData?.billing_address?.address_1}}
              {{userData?.billing_address?.land_mark}},{{userData?.billing_address?.state}},{{userData.billing_address?.pincode}}
            </p>
            <p class="mt-2 text-sm text-gray-500 font-medium"
              *ngIf="userData?.billing_address?.receiver_phone_no || userData?.phone_number">Contact: <span
                class="font-bold text-black">{{userData?.billing_address?.receiver_phone_no ?
                userData.billing_address?.receiver_phone_no : userData?.phone_number}}</span></p>
            <p class="mt-2 text-sm text-gray-500 font-medium" *ngIf="userData.billing_address?.gstin_number">GST: <span
                class="font-bold text-black">{{userData.billing_address?.gstin_number}}</span></p>
          </div>
          <div
            class="flex flex-wrap justify-between items-center gap-2 mt-4 text-sm font-bold text-blue-500 max-md:border-t max-md:border-gray-100 max-md:pt-3 max-md:justify-start">

            <!-- Desktop/Tablet: Remove on left -->
            <button class="text-blue-500 text-sm font-bold max-md:hidden hover:underline"
              (click)="confirmRemoveAddress(userData?.billing_address?.id)">Remove</button>

            <!-- Mobile: Edit on left, separator, Remove on right -->
            <button class="hidden max-md:flex items-center gap-1 text-sm font-semibold"
              [class.text-blue-500]="!userData?.billing_address?.gstin_number"
              [class.text-gray-400]="userData?.billing_address?.gstin_number"
              [class.cursor-not-allowed]="userData?.billing_address?.gstin_number"
              [class.opacity-50]="userData?.billing_address?.gstin_number"
              [disabled]="userData?.billing_address?.gstin_number"
              (click)="!userData?.billing_address?.gstin_number && editAddress(userData?.billing_address, 'billing')">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
                <path
                  d="M16.6667 12.2229L16.6667 14.4451C16.6667 15.6724 15.6718 16.6673 14.4445 16.6673H5.5556C4.3283 16.6673 3.33337 15.6724 3.33337 14.4451V5.55621C3.33337 4.32891 4.3283 3.33398 5.5556 3.33398H7.77782M12.9449 4.77431L7.11094 10.6083C6.95169 10.7675 6.84314 10.9703 6.79897 11.1912L6.44342 12.9689C6.37345 13.3188 6.68191 13.6272 7.03177 13.5573L8.80953 13.2017C9.03037 13.1575 9.23319 13.049 9.39244 12.8898L15.2264 7.05581M12.9449 4.77431L14.0511 3.6681C14.4966 3.22261 15.2189 3.22261 15.6644 3.6681L16.3326 4.33634C16.7781 4.78183 16.7781 5.50411 16.3326 5.9496L15.2264 7.05581M12.9449 4.77431L15.2264 7.05581"
                  [attr.stroke]="userData?.billing_address?.gstin_number ? '#9CA3AF' : '#307FE1'" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <span>Edit</span>
            </button>
            <span class="hidden max-md:inline-block h-4 w-px bg-gray-300 mx-1 self-center"></span>
            <button class="hidden max-md:block text-blue-500 text-sm font-bold"
              (click)="confirmRemoveAddress(userData?.billing_address?.id)">Remove</button>

          </div>
        </article>
      </div>
    </div>
  </section>

  <!-- Other Addresses -->
  <section class="mt-6" *ngIf="addresses && addresses.length > 0">
    <h2 class="text-lg font-bold text-zinc-700">Other Addresses</h2>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6 w-full mt-4 lg:mb-6 items-stretch">
      <!-- Card: Repeat dynamically -->
      <article
        class="p-4 sm:p-5 border border-gray-200 rounded-xl w-full min-w-0 address-card min-h-[180px] flex flex-col shadow-sm"
        *ngFor="let item of addresses">
        <div class="flex justify-between items-start">
          <div class="flex gap-2 items-center">
            <h3 class="text-lg font-bold text-black">{{item?.receiver_name ? item?.receiver_name : item?.company_name ?
              item?.company_name : userData.first_name + ' ' + userData.last_name}}</h3>

            <!-- <h3 class="text-lg font-bold text-black" *ngIf="item?.receiver_name">{{item?.receiver_name}}</h3>
              <h3 class="text-lg font-bold text-black" *ngIf="item?.company_name">{{item?.company_name}}</h3>
              <h3 class="text-lg font-bold text-black" *ngIf="!item?.company_name && !item?.receiver_name">{{userData?.first_name + ' ' + userData?.last_name}}</h3> -->

            <span class="px-3 py-1 text-sm bg-gray-100 border border-gray-300 rounded-2xl text-black"
              *ngIf="item?.address_type">{{item?.address_type | titlecase}}</span>


          </div>
          <button class="flex items-center gap-1 text-sm font-semibold max-md:hidden"
            [class.text-blue-500]="!item?.gstin_number" [class.text-gray-400]="item?.gstin_number"
            [class.cursor-not-allowed]="item?.gstin_number" [class.opacity-50]="item?.gstin_number"
            [disabled]="item?.gstin_number" (click)="!item?.gstin_number && editAddress(item, 'address')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
              <path
                d="M16.6667 12.2229L16.6667 14.4451C16.6667 15.6724 15.6718 16.6673 14.4445 16.6673H5.5556C4.3283 16.6673 3.33337 15.6724 3.33337 14.4451V5.55621C3.33337 4.32891 4.3283 3.33398 5.5556 3.33398H7.77782M12.9449 4.77431L7.11094 10.6083C6.95169 10.7675 6.84314 10.9703 6.79897 11.1912L6.44342 12.9689C6.37345 13.3188 6.68191 13.6272 7.03177 13.5573L8.80953 13.2017C9.03037 13.1575 9.23319 13.049 9.39244 12.8898L15.2264 7.05581M12.9449 4.77431L14.0511 3.6681C14.4966 3.22261 15.2189 3.22261 15.6644 3.6681L16.3326 4.33634C16.7781 4.78183 16.7781 5.50411 16.3326 5.9496L15.2264 7.05581M12.9449 4.77431L15.2264 7.05581"
                [attr.stroke]="item?.gstin_number ? '#9CA3AF' : '#307FE1'" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Edit</span>
          </button>
        </div>
        <div class="flex-grow mt-3">
          <p class="text-sm text-black font-medium leading-relaxed">{{item?.address_1}}
            {{item?.land_mark}},{{item?.state}},{{item?.pincode}}</p>
          <p class="mt-2 text-sm text-gray-500 font-medium">Contact: <span
              class="font-bold text-black">{{item?.receiver_phone_no ? item?.receiver_phone_no : item?.phone_no}}</span>
          </p>
          <p class="mt-2 text-sm text-gray-500 font-medium" *ngIf="item?.gstin_number">GST: <span
              class="font-bold text-black">{{item?.gstin_number}}</span></p>
        </div>
        <div
          class="flex flex-wrap items-center gap-x-4 gap-y-2 mt-4 text-sm font-bold text-blue-500 max-md:pt-3 max-md:border-t max-md:border-gray-100 max-md:justify-start">
          <!-- Desktop/Tablet: Remove, Set as delivery, Set as billing -->
          <button class="text-blue-500 text-sm font-bold max-md:hidden hover:underline"
            (click)="confirmRemoveAddress(item?.id)">Remove</button>
          <button (click)="onSelect(item,'delivery')" class="text-blue-500 text-sm font-bold max-md:hidden hover:underline">Set as
            delivery</button>
          <button (click)="onSelect(item,'billing')" class="text-blue-500 text-sm font-bold max-md:hidden hover:underline">Set as
            billing</button>

          <!-- Mobile: Edit, separator, Remove, Set as delivery, Set as billing -->
          <button class="hidden max-md:flex items-center gap-1 text-sm font-semibold"
            [class.text-blue-500]="!item?.gstin_number" [class.text-gray-400]="item?.gstin_number"
            [class.cursor-not-allowed]="item?.gstin_number" [class.opacity-50]="item?.gstin_number"
            [disabled]="item?.gstin_number" (click)="!item?.gstin_number && editAddress(item, 'address')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
              <path
                d="M16.6667 12.2229L16.6667 14.4451C16.6667 15.6724 15.6718 16.6673 14.4445 16.6673H5.5556C4.3283 16.6673 3.33337 15.6724 3.33337 14.4451V5.55621C3.33337 4.32891 4.3283 3.33398 5.5556 3.33398H7.77782M12.9449 4.77431L7.11094 10.6083C6.95169 10.7675 6.84314 10.9703 6.79897 11.1912L6.44342 12.9689C6.37345 13.3188 6.68191 13.6272 7.03177 13.5573L8.80953 13.2017C9.03037 13.1575 9.23319 13.049 9.39244 12.8898L15.2264 7.05581M12.9449 4.77431L14.0511 3.6681C14.4966 3.22261 15.2189 3.22261 15.6644 3.6681L16.3326 4.33634C16.7781 4.78183 16.7781 5.50411 16.3326 5.9496L15.2264 7.05581M12.9449 4.77431L15.2264 7.05581"
                [attr.stroke]="item?.gstin_number ? '#9CA3AF' : '#307FE1'" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Edit</span>
          </button>
          <span class="hidden max-md:inline-block h-4 w-px bg-gray-300 mx-1 self-center"></span>
          <button class="hidden max-md:block text-blue-500 text-sm font-bold"
            (click)="confirmRemoveAddress(item?.id)">Remove</button>
          <span class="hidden max-md:inline-block h-4 w-px bg-gray-300 mx-1 self-center"></span>
          <button (click)="onSelect(item,'delivery')" class="hidden max-md:block text-blue-500 text-sm font-bold">Set as
            delivery</button>
          <span class="hidden max-md:inline-block h-4 w-px bg-gray-300 mx-1 self-center"></span>
          <button (click)="onSelect(item,'billing')" class="hidden max-md:block text-blue-500 text-sm font-bold">Set as
            billing</button>
        </div>
      </article>

      <!-- Example card structure for reference -->
      <!-- Repeat above article for other cards -->
    </div>
  </section>
</main>

<section *ngIf="showAddressForm" class="w-full max-w-full pb-24 md:pb-0">
  <form [formGroup]="addressForm" (ngSubmit)="onSave()"
    class="w-full bg-[#F8FBFF] md:bg-white rounded-2xl border border-blue-400 p-4 sm:p-6 md:p-8 transition-all">

    <!-- Card Header -->
    <div class="flex justify-between items-center mb-1 max-md:gap-3">
      <div class="flex items-center gap-2 sm:gap-3">
        <button *ngIf="hasSavedAddresses" type="button" (click)="onCloseBillingDetails()"
          class="text-gray-500 hover:text-black p-1 rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
          title="Back to saved addresses">
          <svg class="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        <h2 class="text-xl sm:text-2xl font-bold text-black">
          {{ isEditMode ? 'Edit address' : 'Add an address' }}
        </h2>
      </div>

      <!-- Add GSTIN invoice toggle -->
      <label *ngIf="canAddGstDetails" class="relative inline-flex items-center cursor-pointer select-none">
        <input type="checkbox" class="sr-only peer" [checked]="isGSTEnabled"
          (change)="toggleGST($any($event.target).checked)">
        <div
          class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
        </div>
        <span class="ms-2.5 sm:ms-3 text-xs sm:text-sm font-bold text-black">Add GSTIN invoice</span>
      </label>
    </div>

    <p class="text-xs sm:text-sm text-gray-500 mb-5">Delivery details and billing details will be the same.</p>

    <!-- GSTIN Section (when toggle is ON) -->
    <ng-container *ngIf="isGSTEnabled">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-xs sm:text-sm font-bold text-zinc-700 mb-1.5">
            GSTIN <span class="text-red-500">*</span>
          </label>
          <input type="text" formControlName="gstin" placeholder="Enter GSTIN Number" maxlength="15"
            (keydown)="preventLeading($event, $event.target)"
            class="w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm text-black uppercase focus:outline-none focus:border-blue-500"
            (input)="onGstinChange()" (blur)="onGstinBlur()" />
          <div class="text-red-500 text-xs mt-1" *ngIf="addressForm.get('gstin')?.touched && addressForm.get('gstin')?.invalid">
            <span *ngIf="addressForm.get('gstin')?.hasError('required')">GSTIN is required</span>
            <span *ngIf="addressForm.get('gstin')?.hasError('invalidGstin')">{{ addressForm.get('gstin')?.errors?.['invalidGstin'] }}</span>
          </div>
          <div class="text-red-500 text-xs mt-1" *ngIf="gstinError">{{ gstinError }}</div>
          <div class="text-blue-500 text-xs mt-1" *ngIf="isGstinLoading">Fetching company details...</div>
        </div>

        <div>
          <label class="block text-xs sm:text-sm font-bold text-zinc-700 mb-1.5">
            Company Name <span class="text-red-500">*</span>
          </label>
          <input type="text" formControlName="companyName" placeholder="Registered company name"
            class="w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm text-black focus:outline-none focus:border-blue-500"
            (keydown)="preventLeading($event, $event.target)" />
          <div class="text-red-500 text-xs mt-1" *ngIf="addressForm.get('companyName')?.touched && addressForm.get('companyName')?.invalid">
            Company name is required
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Non-GSTIN / Standard Receiver Fields -->
    <ng-container *ngIf="!isGSTEnabled">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-xs sm:text-sm font-bold text-zinc-700 mb-1.5">
            Receiver/Company Name <span class="text-red-500">*</span>
          </label>
          <input type="text" formControlName="receiverName" placeholder="Enter receivers full name"
            (keydown)="preventLeadingSpace($event, $event.target)"
            class="w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm text-black focus:outline-none focus:border-blue-500" />
          <div class="text-red-500 text-xs mt-1" *ngIf="addressForm.get('receiverName')?.touched && addressForm.get('receiverName')?.invalid">
            Receiver name is required
          </div>
        </div>

        <div>
          <label class="block text-xs sm:text-sm font-bold text-zinc-700 mb-1.5">
            Receiver/Company Phone Number <span class="text-red-500">*</span>
          </label>
          <input type="tel" formControlName="receiverPhone" placeholder="Enter 10-digit mobile number" maxlength="10"
            class="w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm text-black focus:outline-none focus:border-blue-500"
            (keypress)="onNumberOnly($event)" (paste)="onPaste($event)"
            (keydown)="preventLeadingPincode($event, $event.target)" />
          <div class="text-red-500 text-xs mt-1" *ngIf="addressForm.get('receiverPhone')?.touched && addressForm.get('receiverPhone')?.invalid">
            <span *ngIf="addressForm.get('receiverPhone')?.hasError('required')">Phone number is required</span>
            <span *ngIf="addressForm.get('receiverPhone')?.hasError('pattern')">Enter valid 10-digit Indian mobile number</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Flat, House no., Building, Company, Apartment (Full width, taller on mobile) -->
    <div class="mb-4">
      <label class="block text-xs sm:text-sm font-bold text-zinc-700 mb-1.5">
        Flat, House no., Building, Company, Apartment <span class="text-red-500">*</span>
      </label>
      <textarea rows="3" formControlName="address" placeholder="Enter Flat, House no., Building, Company, Apartment"
        class="w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm text-black focus:outline-none focus:border-blue-500 resize-none md:hidden"
        (keydown)="preventLeading($event, $event.target)"></textarea>
      <input type="text" formControlName="address" placeholder="Enter Flat, House no., Building, Company, Apartment"
        class="hidden md:block w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm text-black focus:outline-none focus:border-blue-500"
        (keydown)="preventLeading($event, $event.target)" />
      <div class="text-red-500 text-xs mt-1" *ngIf="addressForm.get('address')?.touched && addressForm.get('address')?.invalid">
        Address is required
      </div>
    </div>

    <!-- Locality & PIN (2 columns) -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label class="block text-xs sm:text-sm font-bold text-zinc-700 mb-1.5">
          Locality <span class="text-red-500">*</span>
        </label>
        <input type="text" formControlName="locality" placeholder="Nearby place"
          class="w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm text-black focus:outline-none focus:border-blue-500"
          (keydown)="preventLeading($event, $event.target)" />
        <div class="text-red-500 text-xs mt-1" *ngIf="addressForm.get('locality')?.touched && addressForm.get('locality')?.invalid">
          Locality is required
        </div>
      </div>

      <div>
        <label class="block text-xs sm:text-sm font-bold text-zinc-700 mb-1.5">
          PIN <span class="text-red-500">*</span>
        </label>
        <input type="text" formControlName="pin" placeholder="e.g. 400615" maxlength="6"
          class="w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm text-black focus:outline-none focus:border-blue-500"
          (keydown)="preventLeadingPincode($event, $event.target)" (blur)="onPincodeBlur()" (input)="onPincodeChange()" />
        <div class="text-red-500 text-xs mt-1" *ngIf="addressForm.get('pin')?.touched && addressForm.get('pin')?.invalid">
          Enter valid 6-digit PIN
        </div>
        <div class="text-red-500 text-xs mt-1" *ngIf="pincodeError">{{ pincodeError }}</div>
        <div class="text-blue-500 text-xs mt-1" *ngIf="isPincodeLoading">Fetching address details...</div>
      </div>
    </div>

    <!-- State & City/Town (2 columns with chevron) -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
      <div>
        <label class="block text-xs sm:text-sm font-bold text-zinc-700 mb-1.5">
          State <span class="text-red-500">*</span>
        </label>
        <div class="relative">
          <input type="text" formControlName="state" placeholder="Select State"
            class="w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 pr-10 text-sm text-black focus:outline-none focus:border-blue-500"
            [readonly]="isPincodeLoading" />
          <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
          </div>
        </div>
        <div class="text-red-500 text-xs mt-1" *ngIf="addressForm.get('state')?.touched && addressForm.get('state')?.invalid">
          State is required
        </div>
      </div>

      <div>
        <label class="block text-xs sm:text-sm font-bold text-zinc-700 mb-1.5">
          City/Town <span class="text-red-500">*</span>
        </label>
        <div class="relative">
          <input type="text" formControlName="city" placeholder="Select City"
            class="w-full bg-white border border-gray-300 rounded-lg px-3.5 py-2.5 pr-10 text-sm text-black focus:outline-none focus:border-blue-500"
            [readonly]="isPincodeLoading" />
          <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
          </div>
        </div>
        <div class="text-red-500 text-xs mt-1" *ngIf="addressForm.get('city')?.touched && addressForm.get('city')?.invalid">
          City is required
        </div>
      </div>
    </div>

    <!-- Save As -->
    <div class="mb-6">
      <h3 class="text-sm font-bold text-black mb-2.5">Save As</h3>
      <div class="flex gap-3 sm:gap-4 flex-wrap">
        <!-- Home -->
        <label class="flex items-center gap-2 px-4 py-2 border rounded-full text-xs sm:text-sm font-semibold cursor-pointer transition-colors"
          [class.bg-[#EBF4FE]]="addressForm.get('saveAs')?.value === 'Home'"
          [class.border-blue-500]="addressForm.get('saveAs')?.value === 'Home'"
          [class.text-blue-900]="addressForm.get('saveAs')?.value === 'Home'"
          [class.bg-white]="addressForm.get('saveAs')?.value !== 'Home'"
          [class.border-gray-300]="addressForm.get('saveAs')?.value !== 'Home'"
          [class.text-gray-700]="addressForm.get('saveAs')?.value !== 'Home'">
          <input type="radio" value="Home" formControlName="saveAs" class="sr-only">
          <svg class="w-4 h-4" [attr.stroke]="addressForm.get('saveAs')?.value === 'Home' ? '#2563eb' : '#4b5563'" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
          </svg>
          <span>Home</span>
        </label>

        <!-- Work -->
        <label class="flex items-center gap-2 px-4 py-2 border rounded-full text-xs sm:text-sm font-semibold cursor-pointer transition-colors"
          [class.bg-[#EBF4FE]]="addressForm.get('saveAs')?.value === 'Work'"
          [class.border-blue-500]="addressForm.get('saveAs')?.value === 'Work'"
          [class.text-blue-900]="addressForm.get('saveAs')?.value === 'Work'"
          [class.bg-white]="addressForm.get('saveAs')?.value !== 'Work'"
          [class.border-gray-300]="addressForm.get('saveAs')?.value !== 'Work'"
          [class.text-gray-700]="addressForm.get('saveAs')?.value !== 'Work'">
          <input type="radio" value="Work" formControlName="saveAs" class="sr-only">
          <svg class="w-4 h-4" [attr.stroke]="addressForm.get('saveAs')?.value === 'Work' ? '#2563eb' : '#4b5563'" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
          </svg>
          <span>Work</span>
        </label>

        <!-- Others -->
        <label class="flex items-center gap-2 px-4 py-2 border rounded-full text-xs sm:text-sm font-semibold cursor-pointer transition-colors"
          [class.bg-[#EBF4FE]]="addressForm.get('saveAs')?.value === 'Others'"
          [class.border-blue-500]="addressForm.get('saveAs')?.value === 'Others'"
          [class.text-blue-900]="addressForm.get('saveAs')?.value === 'Others'"
          [class.bg-white]="addressForm.get('saveAs')?.value !== 'Others'"
          [class.border-gray-300]="addressForm.get('saveAs')?.value !== 'Others'"
          [class.text-gray-700]="addressForm.get('saveAs')?.value !== 'Others'">
          <input type="radio" value="Others" formControlName="saveAs" class="sr-only">
          <svg class="w-4 h-4" [attr.stroke]="addressForm.get('saveAs')?.value === 'Others' ? '#2563eb' : '#4b5563'" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          <span>Others</span>
        </label>
      </div>

      <!-- Custom save as input for Others -->
      <div class="mt-3" *ngIf="addressForm.get('saveAs')?.value === 'Others'">
        <input formControlName="customSaveAs" (keydown)="preventLeading($event, $event.target)"
          class="w-full sm:w-72 bg-white border border-gray-300 rounded-lg px-3.5 py-2 text-sm text-black focus:outline-none focus:border-blue-500"
          placeholder="e.g. Warehouse, Branch Office" required />
        <div *ngIf="addressForm.get('customSaveAs')?.invalid && addressForm.get('customSaveAs')?.touched"
          class="text-red-500 text-xs mt-1">
          This field is required
        </div>
      </div>
    </div>

    <!-- Desktop Save Button (Inside Card, Right-aligned) -->
    <div class="hidden md:flex justify-end pt-2">
      <button type="submit" [disabled]="addressForm.invalid || isPincodeLoading"
        class="px-9 py-2.5 bg-[#0A0A5F] hover:bg-[#070747] text-white text-sm font-bold rounded-lg transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
        {{ isPincodeLoading ? 'Loading...' : 'Save' }}
      </button>
    </div>

    <!-- Mobile Fixed Save Button (Sticky/Fixed at screen bottom) -->
    <div class="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 p-3 shadow-lg">
      <button type="submit" [disabled]="addressForm.invalid || isPincodeLoading"
        class="w-full py-3.5 bg-[#0A0A5F] hover:bg-[#070747] text-white text-base font-bold rounded-lg transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
        {{ isPincodeLoading ? 'Loading...' : 'Save' }}
      </button>
    </div>
  </form>
</section>

<app-address *ngIf="addAdress" [type]="type" [editingAddress]="editingAddress" [isEditMode]="isEditMode"
  (save)="onSaveAddressDetails($event)" (close)="onCloseBillingDetails()" (cancel)="onCloseBillingDetails()"></app-address>

<app-gst *ngIf="addGst" (save)="onSavePopup()" (close)="onCloseGSTINPopup()"></app-gst>

<!-- Delete Address Confirmation Modal -->
<div *ngIf="showDeleteAddressModal" class="fixed inset-0 z-[100] flex items-center justify-center p-4">
  <div class="fixed inset-0 bg-black/50" (click)="cancelRemoveAddress()"></div>
  <div class="relative bg-white rounded-xl shadow-xl max-w-sm w-full mx-auto z-10 overflow-hidden">
    <div class="px-6 pt-6 pb-2">
      <h3 class="text-lg font-bold text-gray-900">Remove Address</h3>
    </div>
    <div class="px-6 pb-5">
      <p class="text-sm text-gray-600">Are you sure you want to remove this address? This action cannot be undone.</p>
    </div>
    <div class="px-6 pb-6 flex gap-3">
      <button type="button" (click)="executeRemoveAddress()" class="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold text-sm rounded-lg transition-colors cursor-pointer">
        Yes, Remove
      </button>
      <button type="button" (click)="cancelRemoveAddress()" class="flex-1 px-4 py-2 border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold text-sm rounded-lg transition-colors cursor-pointer">
        Cancel
      </button>
    </div>
  </div>
</div>